import { combineReducers } from "@reduxjs/toolkit"
import { api } from "./api"

import authReducer from "./slices/authSlice"
import themeReducer from "./slices/themeSlice"
import notificationReducer from "./slices/notificationSlice"
import uploadReducer from "./slices/uploadSlice"
import loadingSlice from "./slices/loadingSlice"
import bannerSlice from "./slices/bannerSlice"
import sliceMySelf from "./slices/sliceMySelf"
import sliceMyAssistant from "./slices/sliceMyAssistant"
import sliceMyDevelopment from "./slices/sliceMyDevelopment"
import sliceMyCalendar from "./slices/sliceMyCalendar"
import sliceBreadcrumb from "./slices/breadcrumbSlice"
import sliceAdmin from "./slices/sliceAdmin"
import sliceAdminMgrLink from "./slices/admin/sliceAdminMgrLink"
import sliceHomePage from "./slices/sliceHomePage"
import procurementReducer from "./slices/procurementSlice"

const appReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  auth: authReducer,
  theme: themeReducer,
  notification: notificationReducer,
  upload: uploadReducer,
  loading: loadingSlice,
  banner: bannerSlice,
  breadcrumb: sliceBreadcrumb,
  homePage: sliceHomePage,
  myCalendar: sliceMyCalendar,
  myAssistant: sliceMyAssistant,
  myDevelopment: sliceMyDevelopment,
  mySelf: sliceMySelf,
  admin: sliceAdmin,
  adminMgrLink: sliceAdminMgrLink,
  procurement: procurementReducer,
})

// `auth/logOut` is dispatched from many places (explicit logout, idle
// timeout, token-refresh failure, lock screen, ...) and none of them reset
// RTK Query's cached responses — so after logging out and back in as a
// different account, every list screen kept serving the previous account's
// cached data (e.g. /procurement/order-requests) until something happened to
// invalidate it. Resetting the api slice here, in one place, covers every
// logout path instead of patching each call site's dispatch sequence.
export const rootReducer = (state, action) => {
  if (action.type === "auth/logOut") {
    state = { ...state, [api.reducerPath]: undefined }
  }
  return appReducer(state, action)
}
